import { render, staticRenderFns } from "./RecursosDeGlosaEdicao.vue?vue&type=template&id=6d1a17f6"
import script from "./RecursosDeGlosaEdicao.vue?vue&type=script&lang=js"
export * from "./RecursosDeGlosaEdicao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports